import Block from "./Block"
import ToitureBanner from "./ToitureBanner"
import toitureItemData from './ToitureItem'

export const Toiture = () => {

    return(
        <>
            <div class="bg-light">
                <ToitureBanner />
                <div className="container">
                    {
                        toitureItemData.map((block, index) => (
                            <Block 
                                key={index}
                                blockTitle={block.blocTitle}
                                blockContent={block.blocContent}
                                hasInput={block.hasInput}
                                inputLabel={block.inputLabel}
                                inputDescription={block.inputDescription}
                            />
                        ))
                    }
                </div>
            </div>
        </>
    )

}